import React, { FC, useEffect } from 'react';
import { useConnection, useUserInfo } from '../../connection/Application';
import { useHistory } from 'react-router-dom';

export const HomePage: FC = () => {
  const user = useUserInfo();
  const connection = useConnection();
  const history = useHistory();
  const sessionLoading = connection.isSessionLoading();

  useEffect(() => {
    if (sessionLoading) {
      return; // wait for the server-side session check before routing
    }
    if (!user) {
      history.replace('/login');
    } else {
      history.replace('/webux/my-goals');
    }
  }, [history, user, sessionLoading]);

  return <div />;
};
